import React, {useState} from 'react';
import {ThumbDownIcon, ThumbUpIcon} from '../../../ui-components/Iconpack';
import Tracker from '../../../lib/analytics/tracker';
import {EventNames, EventProperty} from '../../../lib/analytics/events';

const Feedback = (props: {feedbackText: string; identifier: string; file_uid: string; onFeedbackClick: () => void}) => {
    const [isVisible, setIsVisible] = useState(true);

    const handleThumbsUpClick = () => {
        Tracker.trackEvent(EventNames.GENERIC_FEEDBACK, {
            [EventProperty.Feedback]: 'Good',
            [EventProperty.ID]: props.identifier,
            [EventProperty.FileUid]: props.file_uid,
        });
        props.onFeedbackClick();
        setIsVisible(false);
    };

    const handleThumbsDownClick = () => {
        Tracker.trackEvent(EventNames.GENERIC_FEEDBACK, {
            [EventProperty.Feedback]: 'Bad',
            [EventProperty.ID]: props.identifier,
            [EventProperty.FileUid]: props.file_uid,
        });
        props.onFeedbackClick();
        setIsVisible(false);
    };

    return isVisible ? (
        <div className='my-4 flex flex-col items-center space-y-1'>
            <span className='py-1 text-[12px] font-[200] text-[#FFF]'>{props.feedbackText}</span>
            <div className='flex items-center space-x-2'>
                <div className={'cursor-pointer'} onClick={handleThumbsUpClick}>
                    <ThumbUpIcon />
                </div>
                <div className={'cursor-pointer'} onClick={handleThumbsDownClick}>
                    <ThumbDownIcon />
                </div>
            </div>
        </div>
    ) : null;
};

export default Feedback;
